/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CitizenshipDto } from './citizenship-dto';
import {
    CitizenshipDtoFromJSON,
    CitizenshipDtoFromJSONTyped,
    CitizenshipDtoToJSON,
    CitizenshipDtoToJSONTyped,
} from './citizenship-dto';

/**
 * Список гражданств
 * @export
 * @interface GetCitizenshipsResponseDto
 */
export interface GetCitizenshipsResponseDto {
    /**
     * Список гражданств
     * @type {Array<CitizenshipDto>}
     * @memberof GetCitizenshipsResponseDto
     */
    citizenships: Array<CitizenshipDto>;
}

/**
 * Check if a given object implements the GetCitizenshipsResponseDto interface.
 */
export function instanceOfGetCitizenshipsResponseDto(value: object): value is GetCitizenshipsResponseDto {
    if (!('citizenships' in value) || value['citizenships'] === undefined) return false;
    return true;
}

export function GetCitizenshipsResponseDtoFromJSON(json: any): GetCitizenshipsResponseDto {
    return GetCitizenshipsResponseDtoFromJSONTyped(json, false);
}

export function GetCitizenshipsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCitizenshipsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'citizenships': ((json['citizenships'] as Array<any>).map(CitizenshipDtoFromJSON)),
    };
}

  export function GetCitizenshipsResponseDtoToJSON(json: any): GetCitizenshipsResponseDto {
      return GetCitizenshipsResponseDtoToJSONTyped(json, false);
  }

  export function GetCitizenshipsResponseDtoToJSONTyped(value?: GetCitizenshipsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'citizenships': ((value['citizenships'] as Array<any>).map(CitizenshipDtoToJSON)),
    };
}

